import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M8 19L19 12L8 5V19Z" xmlns="http://www.w3.org/2000/svg" />,
  "PlayArrow"
);
